import { useState } from 'react';
import PokeContext from '.';
import apiPokeCall from '../api';

export default function PokemonProvider({ children }) {
	const [pokemons, setPokemons] = useState([]);
	//const [pokemonDetail, setPokemonDetail] = useState({});
	const [erroMessage, setErrorMessage] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [search, setSearching] = useState(false);
    const [favorites, setFavorites] = useState([]);
	const [page, setPage] = useState(0);
	const [total, setTotal] = useState(0);
    
	const url = 'https://pokeapi.co/api/v2/pokemon';

	const getPokemons = async () => {
		try {
			setIsLoading(true);
			setErrorMessage('');
			setHasError(false);
			const pokemonsResult = await apiPokeCall({
				url: url + `?limit=${18}&offset=${18 * page}`,
			});
			const pokePromise = pokemonsResult.results.map(async (pokemon) => {
				return await getPokemonDetail(pokemon.name, true);
			});
			const results = await Promise.all(pokePromise);
			setPokemons(results);
			setTotal(Math.ceil(pokemonsResult.count / 18));
		} catch (error) {
			setPokemons([]);
			setErrorMessage('Error inesperado' + error);
			setHasError(true);
		} finally {
			setIsLoading(false);
		}
	};

	const getPokemonDetail = async (pokemon, bool = false) => {
		try {
            if(!pokemon) return getPokemons();
			setSearching(true);
			setIsLoading(true);
			setErrorMessage('');
			setHasError(false);
			const pokemonData = await apiPokeCall({ url: url + "/" + pokemon });
			if(bool){
				return pokemonData;
			}else{
				setPokemons([pokemonData]);
			}
            setPage(0);
			setTotal(1);
		} catch (error) {
			setPokemons([]);
			setErrorMessage('Error inesperado');
			setHasError(true);
		} finally {
			setIsLoading(false);
			setSearching(false);
		}
	};

	const updateFavoritePokemon = (name) => {
        var updated = [...favorites];
		const isFavorite = updated.indexOf(name);

		if (isFavorite >= 0) {
			//el primer parametro la posicón y el segundo la cantidad a borrar desde la cantidad
			//indicada
			updated.splice(isFavorite, 1);
		} else {
			updated.push(name);
		}
		setFavorites(updated);
		window.localStorage.setItem('favorite_pokemon', JSON.stringify(updated));
    };

	return (
		<PokeContext.Provider
			value={{
				getPokemons,
                pokemons,

				getPokemonDetail,
                /* pokemonDetail, */

				updateFavoritePokemon,
                setFavorites,
                favorites,
                
                setPage,
                page,
                
                isLoading,
                hasError,
                erroMessage,
                total,
				search,
			}}
		>
			{children}
		</PokeContext.Provider>
	);
}
